/* ============================================================
   main-collection.js
   Combined controllers for the collection section, externalized
   verbatim from the section's three inline <script> blocks:
     1. Mobile bar router (dispatch mfd:open / mfd-sort:open)
     2. Escape drawers from sidebar (re-parent to <body>)
     3. Hybrid infinite scroll + Show More pagination

   No Liquid/Shopify data inside any block — all config is read
   from data-* attributes at runtime. Run-once guarded.

   Block 3 (infinite scroll) is gated in Liquid by
   {% if section.settings.pagination_type == 'infinite' %}; here it
   is always present but no-ops when no .infinite-scroll-container
   exists on the page, so behaviour is unchanged. The history
   pushState/replaceState patch is preserved exactly.
   ============================================================ */
(function () {
  if (window.__cdMainCollectionLoaded) return;
  window.__cdMainCollectionLoaded = true;

  /* ===== BLOCK 1 — Mobile bar router ===== */
  (function () {
    document.addEventListener('click', function (e) {
      var half = e.target.closest('.mfb-bar-half[data-action]');
      if (!half) return;

      var action = half.dataset.action;

      if (action === 'sort') {
        /* Dispatch the sort-drawer open event */
        document.dispatchEvent(new CustomEvent('mfd-sort:open'));
      } else if (action === 'filter') {
        /* Dispatch the filter-drawer open event */
        document.dispatchEvent(new CustomEvent('mfd:open'));
      }
    });
  })();

  /* ===== BLOCK 2 — Escape drawers from sidebar ===== */
  (function () {
    function escapeDrawersFromSidebar() {
      ['mfd-drawer', 'mfd-overlay', 'mfd-sort-drawer', 'mfd-sort-overlay'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.parentElement !== document.body) {
          document.body.appendChild(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', escapeDrawersFromSidebar);
    } else {
      escapeDrawersFromSidebar();
    }
  })();

  /* ===== BLOCK 3 — Hybrid infinite scroll + Show More pagination ===== */
  (function() {
    'use strict';

    /* ─────────────────────────────────────────────────────────────────────
       Module-level state — only one IntersectionObserver active at a time.
    ───────────────────────────────────────────────────────────────────── */
    var activeObserver   = null;   // current IntersectionObserver instance
    var activeContainer  = null;   // the .infinite-scroll-container we are watching

    /* ─────────────────────────────────────────────────────────────────────
       initInfiniteScroll()
       Finds the current .infinite-scroll-container in the DOM, tears down
       any previous observer, and starts a fresh one.
       Safe to call multiple times — idempotent.
    ───────────────────────────────────────────────────────────────────── */
    function initInfiniteScroll() {
      var container = document.querySelector('.infinite-scroll-container');

      /* Nothing to do if there is no container or it has no next page. */
      if (!container || !container.dataset.nextUrl) {
        teardownObserver();
        return;
      }

      /* Already watching this exact container — nothing to do. */
      if (container === activeContainer) return;

      /* Tear down any observer attached to a previous container. */
      teardownObserver();

      /* ── Wire up the new container ─────────────────────────────────── */
      activeContainer = container;

      var sentinel      = container.querySelector('.infinite-scroll-sentinel');
      var spinner       = container.querySelector('.loading-spinner');
      var showMoreWrap  = container.querySelector('.infinite-scroll-show-more');
      var showMoreBtn   = container.querySelector('.infinite-scroll-show-more-btn');
      var sectionId     = container.dataset.section;

      var AUTO_LOAD_PAGES = parseInt(container.dataset.autoLoadPages || '2', 10);
      var PAGES_PER_CLICK = parseInt(container.dataset.pagesPerClick || '2', 10);

      var currentNextUrl = container.dataset.nextUrl;
      var loading        = false;
      var autoLoadBudget = AUTO_LOAD_PAGES;

      /* ── Core fetch function ──────────────────────────────────────── */
      function loadNextPage() {
        if (loading || !currentNextUrl) return;
        loading = true;

        if (showMoreBtn) showMoreBtn.disabled = true;
        if (spinner)     spinner.style.display = 'block';

        fetch(currentNextUrl)
          .then(function(response) { return response.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc    = parser.parseFromString(html, 'text/html');

            /* Append new product items to the grid. */
            var newItems       = doc.querySelectorAll('#collection > li');
            var collectionList = document.getElementById('collection');
            if (collectionList && newItems.length) {
              var fragment = document.createDocumentFragment();
              newItems.forEach(function(li) {
                fragment.appendChild(document.importNode(li, true));
              });
              collectionList.appendChild(fragment);
            }

            /* Advance the URL pointer. */
            var newContainer = doc.querySelector('.infinite-scroll-container');
            if (newContainer && newContainer.dataset.nextUrl) {
              currentNextUrl = newContainer.dataset.nextUrl;
              container.dataset.nextUrl = currentNextUrl;
            } else {
              currentNextUrl = null;
            }

            /* Notify other scripts (e.g. quick-shop initialisation). */
            document.dispatchEvent(
              new CustomEvent('theme:ajax:loaded', {
                detail: { sectionId: sectionId, infiniteScroll: true }
              })
            );

            autoLoadBudget -= 1;

            if (!currentNextUrl) {
              /* All pages exhausted. */
              pauseAutoLoad();
              if (showMoreWrap) showMoreWrap.style.display = 'none';
              if (sentinel)     sentinel.style.display     = 'none';
            } else if (autoLoadBudget <= 0) {
              /* Budget spent — pause and show the button. */
              pauseAutoLoad();
              if (showMoreWrap) showMoreWrap.style.display = 'block';
            }
            /* Otherwise budget still available — observer will fire again. */
          })
          .catch(function(error) {
            console.error('Infinite scroll error:', error);
          })
          .finally(function() {
            loading = false;
            if (spinner)     spinner.style.display = 'none';
            if (showMoreBtn) showMoreBtn.disabled  = false;
          });
      }

      /* ── Observer helpers ──────────────────────────────────────────── */
      function startAutoLoad() {
        if (!sentinel || !window.IntersectionObserver) return;

        activeObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && currentNextUrl && !loading) {
              loadNextPage();
            }
          });
        }, { threshold: 0.1, rootMargin: '200px' });

        activeObserver.observe(sentinel);
      }

      function pauseAutoLoad() {
        if (activeObserver) {
          activeObserver.disconnect();
          activeObserver = null;
        }
      }

      /* ── "Show More" click handler ─────────────────────────────────── */
      if (showMoreBtn) {
        /* Remove any listener added by a previous init run. */
        var freshBtn = showMoreBtn.cloneNode(true);
        showMoreBtn.parentNode.replaceChild(freshBtn, showMoreBtn);
        showMoreBtn = freshBtn;

        showMoreBtn.addEventListener('click', function() {
          autoLoadBudget = PAGES_PER_CLICK;
          if (showMoreWrap) showMoreWrap.style.display = 'none';

          startAutoLoad();

          /* Fallback: if IntersectionObserver is unavailable load directly. */
          if (!window.IntersectionObserver) loadNextPage();
        });
      }

      /* ── Kick off the initial auto-load run ────────────────────────── */
      startAutoLoad();

      /* Fallback for browsers without IntersectionObserver. */
      if (!window.IntersectionObserver && showMoreWrap) {
        showMoreWrap.style.display = 'block';
      }
    }

    /* ─────────────────────────────────────────────────────────────────────
       teardownObserver()
       Disconnects the active IntersectionObserver and resets module state.
    ───────────────────────────────────────────────────────────────────── */
    function teardownObserver() {
      if (activeObserver) {
        activeObserver.disconnect();
        activeObserver = null;
      }
      activeContainer = null;
    }

    /* ─────────────────────────────────────────────────────────────────────
       Re-init on theme AJAX events.

       The theme (and our own loadNextPage above) dispatches
       'theme:ajax:loaded' after every AJAX content update.  We ignore
       events that come from our own loadNextPage (they carry
       detail.infiniteScroll = true) to avoid an unnecessary re-init loop
       in the middle of a scroll run.
    ───────────────────────────────────────────────────────────────────── */
    document.addEventListener('theme:ajax:loaded', function(e) {
      /* Skip events fired by our own infinite-scroll page fetches. */
      if (e.detail && e.detail.infiniteScroll) return;

      /*
       * A filter or sort change has caused the theme to swap in new
       * collection content.  Wait one tick for the DOM to settle, then
       * re-initialise.
       */
      setTimeout(initInfiniteScroll, 100);
    });

    /* ─────────────────────────────────────────────────────────────────────
       Re-init when the URL changes via pushState / replaceState / popstate.
       Desktop AJAX filter systems typically call history.pushState after
       swapping the product grid — this catches that case even if the theme
       does not fire 'theme:ajax:loaded'.
    ───────────────────────────────────────────────────────────────────── */
    (function patchHistory() {
      function wrap(original) {
        return function() {
          var result = original.apply(this, arguments);
          setTimeout(initInfiniteScroll, 150);
          return result;
        };
      }

      if (history.pushState) {
        history.pushState    = wrap(history.pushState);
        history.replaceState = wrap(history.replaceState);
      }

      window.addEventListener('popstate', function() {
        setTimeout(initInfiniteScroll, 150);
      });
    })();

    /* ─────────────────────────────────────────────────────────────────────
       MutationObserver safety-net.
       Watches the document body for a new .infinite-scroll-container
       being injected, covering any AJAX / Section Rendering API path that
       does not fire 'theme:ajax:loaded' or touch history.
    ───────────────────────────────────────────────────────────────────── */
    if (window.MutationObserver) {
      var domObserver = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;

            /* Check the node itself or any descendant. */
            if (
              node.classList && node.classList.contains('infinite-scroll-container') ||
              node.querySelector && node.querySelector('.infinite-scroll-container')
            ) {
              setTimeout(initInfiniteScroll, 50);
              return; /* one re-init per mutation batch is enough */
            }
          }
        }
      });

      domObserver.observe(document.body, { childList: true, subtree: true });
    }

    /* ── Initial run on page load ────────────────────────────────────── */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initInfiniteScroll);
    } else {
      initInfiniteScroll();
    }

  })();

})();